import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const API_TAG = "FuelSurcharges";
const SURCHARGE_BASE = "fuelsurcharges";
const buildUrl = (endpoint) => SURCHARGE_BASE + endpoint;

const SHIPPER_SURCHARGE_API_TAG = "Surcharges";
const SHIPPER_SURCHARGE_BASE = "surcharges";
const buildShipperSurchargeUrl = (endpoint) => SHIPPER_SURCHARGE_BASE + endpoint;

export const surchargeSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getFuelSurcharges: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getFuelSurcharges', API_TAG)
        }),
        addFuelSurcharge: builder.mutation({
            query: surchargeInfo => ({
                url: buildUrl(`/add`),
                method: 'POST',
                body: surchargeInfo,
            }),
            invalidatesTags: (result, error, { shipperId }) => [
                { type: API_TAG },
            ],
        }),
        updateFuelSurcharge: builder.mutation({
            query: surchargeInfo => ({
                url: buildUrl(`/${surchargeInfo.id}`),
                method: 'PUT',
                body: surchargeInfo,
            }),
            invalidatesTags: (result, error, { shipperId }) => [
                { type: API_TAG },
            ],
        }),
        deleteFuelSurcharge: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, { shipperId }) => [
                { type: API_TAG },
            ],
        }),
        getSurcharges: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildShipperSurchargeUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: SHIPPER_SURCHARGE_API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getSurcharges', SHIPPER_SURCHARGE_API_TAG)
        }),
        addSurcharge: builder.mutation({
            query: surchargeInfo => ({
                url: buildShipperSurchargeUrl(`/add`),
                method: 'POST',
                body: surchargeInfo,
            }),
            invalidatesTags: () => [
                { type: SHIPPER_SURCHARGE_API_TAG },
            ],
        }),
        updateSurcharge: builder.mutation({
            query: surchargeInfo => ({
                url: buildShipperSurchargeUrl(`/${surchargeInfo.id}`),
                method: 'PUT',
                body: surchargeInfo,
            }),
            invalidatesTags: () => [
                { type: SHIPPER_SURCHARGE_API_TAG },
            ],
        }),
        deleteSurcharge: builder.mutation({
            query: id => ({
                url: buildShipperSurchargeUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: () => [
                { type: SHIPPER_SURCHARGE_API_TAG },
            ],
        }),
    }),
});

export const {
    useGetFuelSurchargesQuery,
    useAddFuelSurchargeMutation,
    useUpdateFuelSurchargeMutation,
    useDeleteFuelSurchargeMutation,
    useGetSurchargesQuery,
    useAddSurchargeMutation,
    useUpdateSurchargeMutation,
    useDeleteSurchargeMutation,
} = surchargeSlice;
